<template>
  <div>
    <!-- Category Module modal -->
    <v-dialog persistent v-model="pageDetailStatus" max-width="400">
      <v-card>
        <v-card-title class="headline">
          <div class="text-center white--text" style="width: 100%">
            {{ this.modalHeader }}
          </div>
        </v-card-title>

        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(sendForm)">
            <v-card-text class="py-3">
              <v-row>
                <v-col align="center" cols="12">
                   <v-avatar size="84" class="profile-avatar" color="var(--primary-color)">
                    <v-img
                      v-if="selectedIcon || categoryModel?.CategoryIconUrl"
                      :src="selectedIcon || categoryModel?.CategoryIconUrl"
                    />
                    <span v-else>
                      -
                    </span>
                  </v-avatar>
                </v-col>
                <v-col
                  v-if="categoryModel.Id"
                  md="12"
                  xs="12"
                  class="px-0 py-0 pl-2 pr-2"
                >
                  <ValidationProvider
                    name="Sıralama"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="categoryModel.categoryIndex"
                      :value="categoryModel.categoryIndex"
                      :label="$t('labels.categoryIndex')"
                      :error-messages="errors[0]"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col md="12" xs="12" class="px-0 py-0 pl-2 pr-2">
                  <ValidationProvider
                    :name="$t('titles.name')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="categoryModel.CategoryName"
                      :value="categoryModel.CategoryName"
                      :label="$t('titles.name')"
                      :error-messages="errors[0]"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col md="12" xs="4" class="px-0 pl-2 pr-2">
                  <ValidationProvider name="Type" v-slot="{ errors }">
                    <v-autocomplete
                      v-model="categoryModel.ParentId"
                      :items="selecBoxCategories"
                      :error-messages="errors[0]"
                      item-text="CategoryName"
                      item-value="Id"
                      dense
                      :disabled="selectedCategoriesModal.length == 1"
                      :label="$t('labels.parentCategory')"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
                <v-col md="12" xs="4" class="px-0 pl-2 pr-2">
                 <ValidationProvider
                    :name="'Kategori Görseli'"
                    v-slot="{ errors }"
                  >
                    <v-file-input
                      v-model="categoryModel.IconFile"
                      label="Kategori Görseli Yükle"
                      outlined
                      :error-messages="errors[0]"
                      accept="image/*"
                      @change="onFileChange"
                    ></v-file-input>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions
              style="
                background-color: white;
                position: sticky;
                bottom: 0px;
                border-top: solid grey 2px;
              "
            >
              <v-spacer></v-spacer>
              <v-btn color="primary" type="submit" :loading="loadings.send">
                {{ $t("buttons.save") }}
              </v-btn>
              <v-btn
                color="primary"
                text
                @click="
                  pageDetailStatus = false;
                  clearModal();
                "
              >
                {{ $t("buttons.close") }}
              </v-btn>
            </v-card-actions>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>

    <!-- Category Module deletion modal -->
    <delete-modal :yesFunc="deleteItem" ref="deleteModalRef" />

    <v-card style="border-radius: 10px">
     <v-card-title style="color: #595959">
       <v-row align="center" justify="space-between">
          <v-col cols="auto">
            <div class="text-h6">
              Kategoriler
            </div>
          </v-col>
        </v-row>
      </v-card-title>

      <v-divider />

      <v-card-title class="pb-0">
        <v-row align="center" justify="space-between" class="mb-2">
          <v-col cols="12" md="5">
            <v-text-field
              v-model="search"
              :label="$t('labels.search')"
              clear-icon="mdi-close-circle"
              clearable
              single-line
              hide-details
              class="mb-5"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="auto" class="d-sm-flex justify-center" style="gap: 10px;">
            <v-btn
              @click="
                pageDetailStatus = true;
                selectedCategoriesModal = [];
                modalHeader = $t('title.categoryCreate');
              "
              small
              elevation="0"
              outlined
              color="var(--primary-color)"
            >
              <v-icon left small>mdi-plus</v-icon>
              {{ $t("buttons.addNew") }}
            </v-btn>
            <v-btn
              small
              elevation="0"
              outlined
              color="info"
              v-if="
                selectedCategoriesModal.length == 1 &&
                  controlUpdateButton == true
              "
              @click="getPageDetails(selectedCategoriesModal)"
            >
              <v-icon color="info" left small>mdi-pencil</v-icon>
              {{ $t("labels.tooltipEdit") }}
            </v-btn>
            <v-btn
              small
              elevation="0"
              outlined
              color="error"
              v-if="selectedCategoriesModal.length == 1"
              @click="openDeleteModal(selectedCategoriesModal)"
            >
              <v-icon color="error" left small>mdi-delete</v-icon>
              {{ $t("buttons.deleteSelectedCategory") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="px-0 py-0">
        <v-banner rounded outlined>
          <v-treeview
            v-if="cData != null"
            v-model="selectedCategoriesModal"
            :items="cData"
            :search="search"
            :filter="filter"
            selection-type="independent"
            item-children="Children"
            item-value="Id"
            item-text="CategoryName"
            item-key="Id"
            selectable
            rounded
            return-object
          >
          </v-treeview>
        </v-banner>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CategoryService from "../services/CategoryService";
import DeleteModal from "../components/General/DeleteModal.vue";

import _ from "lodash";
import FileService from "../services/FileService.js";
import { isNumber } from "lodash";

const SAMPLE = [
        {
          "ParentId": 0,
          "CategoryIndex": 1,
          "CategoryName": "SSS Çalışan",
          "CategoryIconUrl": "https://aksainfo.aksa.com/wp-content/uploads/2020/05/Screen-Shot-2020-05-20-at-13.18.41-110x110.png",
          "Parent": null,
          "Children": [
            {
              "ParentId": 4,
              "CategoryIndex": 0,
              "CategoryName": "Fazla Mesai",
              "CategoryIconUrl": "https://aksainfo.aksa.com/wp-content/uploads/2020/07/yoneticilere-tavsiye-yeni-110x110.jpg",
              "Parent": null,
              "Children": null,
              "Id": 5,
              "CreatedAt": "2026-06-03T07:19:04.8741786Z",
              "UpdatedAt": null,
              "DeletedAt": null,
              "Status": 10,
              "IsAllGroups": false
            }
          ],
          "Id": 4,
          "CreatedAt": "2026-06-03T07:19:04.8741786Z",
          "UpdatedAt": null,
          "DeletedAt": null,
          "Status": 10,
          "IsAllGroups": false
        },
      ];

export default {
  data: () => ({
    selectedIcon: null,
    //List options
    options: {
      itemsPerPage: 15,
    },
    top: 15,
    skip: 0,
    tableData: [],
    //Table contents
    headers: [],
    //Page loaders
    loadings: {
      table: false,
      send: false,
    },
    //Initial models
    pageDetailStatus: false,
    pageDetailUpdate: false,
    modalHeader: "",
    modalHeaderUpdate: "",
    deleteItemModel: {},
    categoryModel: {
      trName: "",
      enName: "",
      Id: "",
      categoryIndex: "",
    },
    search: "",
    parentId: null,
    selecBoxCategories: [],
    selectedFilterParentId: "All",
    cData: null,
    selectedCategoriesModal: [],
    searchCategoryModel: "",
    caseSensitive: false,
    controlUpdateButton: false,
    key: null,
  }),
  watch: {
    pageDetailStatus(newValue){
      if(!newValue){
        this.selectedIcon = null;
        this.clearModal()
      }
    },
    selectedCategoriesModal: function(val) {
      let obj = this.cData.find((o) => o.Id === val[0]);
      if (obj == undefined) {
        this.controlUpdateButton = true;
      } else {
        this.controlUpdateButton = true;
      }
    },
  },
  computed: {
    filter() {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined;
    },
  },
  mounted() {
    this.setup();
    this.getCategories();
    //this.getTableList(this.parentId, true);
  },
  components: {
    DeleteModal,
  },
  methods: {
    onFileChange(file) {
      if (!file) {
        this.selectedIcon = null;
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        this.selectedIcon = e.target.result;
      };

      reader.readAsDataURL(file);
    },
    //Sets up the page on mount
    setup() {
      this.modalHeader = this.$t("title.groupModalCreate");
      this.modalHeaderUpdate = this.$t("title.groupModalUpdate");
      this.headers = [
        {
          text: this.$t("title.tableHeaderTrName"),
          value: "Translation",
          sortable: false,
        },
        {
          text: this.$t("title.tableHeaderCreateDate"),
          value: "CreatedAt",
          sortable: false,
        },
        {
          text: this.$t("title.parentName"),
          value: "ParentId",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("title.tableHeaderActions"),
          value: "actions",
          sortable: false,
        },
      ];
    },

    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 40;
    },

    getCategories(parentId = null, selectBoxItems = true) {
      this.$store.state.loadingStatus = true;
      CategoryService.getCategories({ ParentId: parentId })
      .then((response) => {
        const data = response?.data?.Data;
        if(Array.isArray(data) && data.length > 0){
          this.cData = data;
          selectBoxItems ? this.setSelectBoxItems(data) : null;
        }
      })
      .catch(window.showError)
      .finally(() => this.$store.state.loadingStatus = false);
    },

    getTableList(parentId = null, selectBoxItems = false) {
      return
      this.$store.state.loadingStatus = true;
      CategoryService.getCategories(parentId)
        .then((response) => {
          console.log("res : ", response.data);

          const data = response?.data?.Data;
          if(Array.isArray(data) && data.length > 0){
            this.tableData = data;
            selectBoxItems ? this.setSelectBoxItems(data) : null;
          }
        })
        .catch(window.showError)
        .finally(() => this.$store.state.loadingStatus = false);
    },

    /**
     * 
     * @param {[]} data 
     */
    setSelectBoxItems(data) {
      this.selecBoxCategories = data?.map(item => ({
        Id: item.Id,
        ParentId: item.ParentId,
        CategoryName: item.CategoryName
      }));
    },

    //Inspects an item
    getPageDetails(items) {
      const selectedItem = items[0];
      if(!selectedItem) return;

      console.log(selectedItem)

      this.modalHeader = this.$t("title.categoryModalUpdate");
      this.categoryModel = {
        CategoryName: selectedItem.CategoryName,
        Id: selectedItem.Id,
        ParentId: selectedItem.ParentId,
        categoryIndex: selectedItem.CategoryIndex,
        CategoryIconUrl: selectedItem.CategoryIconUrl,
      };
      this.pageDetailStatus = true;
    },

    //Clear modal and its content
    clearModal() {
      this.categoryModel = {
        CategoryName: "",
        Id: "",
      };
      this.selectedCategoriesModal = [];
      this.$refs.observer.reset();
    },

    deleteItem() {
      this.$store.state.loadingStatus = true;
      CategoryService.deleteCategory(this.deleteItemModel)
        .then((res) => {
          this.getTableList();
          this.getCategories();
          this.$refs.deleteModalRef.modalStatus = false;
          this.deleteItemModel = null;
          window.showInfo("Kategori Silindi", "standart", "success");
        })
        .catch(window.showError)
        .finally(() => this.$store.state.loadingStatus = false);
    },

    sendForm() {
      if (this.categoryModel.Id) {
        this.updateCategory();
      } else {
        this.createCategory();
      }
    },

    //Create operation
    async createCategory() {
      const file = this.categoryModel.IconFile;
      
      let categoryIconUrl = "";

      if(file){
         const formData = new FormData();
        formData.append("Files", file)
        formData.append("Type", 1)
        const { data } = await FileService.uploadFile(formData);
        
        if(Array.isArray(data) && data.length > 0){
          categoryIconUrl = data[0]?.LocalUrl;
        }
      }

      this.$store.state.loadingStatus = true;

      let body = {
        "ParentId": this.categoryModel.ParentId,
        "CategoryIndex": this.categoryModel.CategoryIndex,
        "CategoryName": this.categoryModel.CategoryName,
        "CategoryIconUrl": categoryIconUrl
      };
      
      CategoryService.createCategory(body)
        .then((response) => {
          this.getTableList(this.parentId, true);
          this.getCategories();
          this.pageDetailStatus = false;

          this.clearModal();
          window.showInfo("Kategori Eklendi", "standart", "success");

          this.pageDetailStatus = false;
        })
        .catch(window.showError)
        .finally(() => this.$store.state.loadingStatus = false);
    },

    //Update operation
    async updateCategory() {
      const file = this.categoryModel.IconFile;
      let categoryIconUrl = this.categoryModel.CategoryIconUrl;

      if(file){
         const formData = new FormData();
        formData.append("Files", file)
        formData.append("Type", 1)
        const { data } = await FileService.uploadFile(formData);
        
        if(Array.isArray(data) && data.length > 0){
          categoryIconUrl = data[0]?.LocalUrl || this.categoryModel.CategoryIconUrl;
        }
      }

      const body = {
        "Id": this.categoryModel.Id,
        "ParentId": this.categoryModel.ParentId,
        "CategoryIndex": Number(this.categoryModel.categoryIndex),
        "CategoryName": this.categoryModel.CategoryName,
        CategoryIconUrl: categoryIconUrl
      };
      
      this.$store.state.loadingStatus = true;
      CategoryService.updateCategory(body)
      .then((res) => {
        window.showSuccess('Başarılı bir şekilde güncellendi.')
        this.getTableList()
        this.getCategories()

        this.pageDetailStatus = false;
      })
      .catch(window.showError)
      .finally(() => this.$store.state.loadingStatus = false);
    },

    /**
     * Open Delete Modal
     * @param  {number[]} items
     */
    openDeleteModal(items) {
      if(!Array.isArray(items)) return;
      
      this.deleteItemModel = items[0]?.Id;
      this.$refs.deleteModalRef.modalStatus = true;
    },

    //Search Operation
    searchTable(type = "search") {
      type == "clear" ? (this.search = "") : null;
      this.getTableList(this.selectedFilterParentId);
    },

    filteredCategories() {
      console.log("parent ıd ", this.selectedFilterParentId);
      this.getTableList(this.selectedFilterParentId, false);
    },
  },
};
</script>
